import _asyncToGenerator from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["prefix", "field", "errors"];
import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { CardElement as me } from "@stripe/react-stripe-js";
import D from "react";
function T(e) {
  var t = e.prefix,
    s = e.field,
    r = e.errors,
    i = _objectWithoutProperties(e, _excluded);
  if (r == null) return null;
  var a = s ? r.getFieldErrors(s) : r.getFormErrors();
  return a.length === 0 ? null : D.createElement("div", _objectSpread({}, i), t ? "".concat(t, " ") : null, a.map(function (l) {
    return l.message;
  }).join(", "));
}
import { createClient as g, getDefaultClient as C } from "@formspree/core";
import { Elements as V } from "@stripe/react-stripe-js";
import { loadStripe as j } from "@stripe/stripe-js/pure.js";
import b, { useContext as R, useEffect as E, useMemo as w, useState as M } from "react";
var v = b.createContext(null);
function _(e) {
  var t = e.children,
    s = e.project,
    r = e.stripePK,
    _M = M(g({
      project: s
    })),
    _M2 = _slicedToArray(_M, 2),
    i = _M2[0],
    a = _M2[1],
    l = w(function () {
      return r ? j(r) : null;
    }, [r]);
  return E(function () {
    var n = !0;
    return n && a(function (o) {
      return o.project !== s ? g(_objectSpread(_objectSpread({}, o), {}, {
        project: s
      })) : o;
    }), function () {
      n = !1;
    };
  }, [s]), E(function () {
    var n = !0;
    return l !== null && l !== void 0 && l.then(function (o) {
      n && o && a(function (m) {
        return g(_objectSpread(_objectSpread({}, m), {}, {
          stripe: o
        }));
      });
    }), function () {
      n = !1;
    };
  }, [l]), b.createElement(v.Provider, {
    value: {
      client: i
    }
  }, l ? b.createElement(V, {
    stripe: l
  }, t) : t);
}
function F() {
  var _R;
  return (_R = R(v)) !== null && _R !== void 0 ? _R : {
    client: C()
  };
}
import { useState as d } from "react";
import { appendExtraData as A, isSubmissionError as H } from "@formspree/core";
import { CardElement as B } from "@stripe/react-stripe-js";
import { useMemo as K } from "react";
var P = "2.5.1";
var N = "@formspree/react@".concat(P);
function x(e) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var s = F(),
    _t$client = t.client,
    r = _t$client === void 0 ? s.client : _t$client,
    i = t.extraData,
    a = t.onError,
    l = t.onSuccess,
    n = t.origin,
    o = r.stripe,
    m = K(function () {
      return o === null || o === void 0 ? void 0 : o.elements().getElement(B);
    }, [o]);
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(p) {
      var u, _i, _Object$entries, _Object$entries$_i, h, y, c, f;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            u = O(p) ? U(p) : p;
            if (!(typeof i == "object")) {
              _context.next = 17;
              break;
            }
            _i = 0, _Object$entries = Object.entries(i);
          case 3:
            if (!(_i < _Object$entries.length)) {
              _context.next = 17;
              break;
            }
            _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2), h = _Object$entries$_i[0], y = _Object$entries$_i[1];
            c = void 0;
            if (!(typeof y == "function")) {
              _context.next = 12;
              break;
            }
            _context.next = 9;
            return y();
          case 9:
            c = _context.sent;
            _context.next = 13;
            break;
          case 12:
            c = y;
          case 13:
            c !== void 0 && A(u, h, c);
          case 14:
            _i++;
            _context.next = 3;
            break;
          case 17:
            _context.next = 19;
            return r.submitForm(e, u, {
              endpoint: n,
              clientName: N,
              createPaymentMethod: o && m ? function () {
                return o.createPaymentMethod({
                  type: "card",
                  card: m,
                  billing_details: z(u)
                });
              } : void 0
            });
          case 19:
            f = _context.sent;
            H(f) ? a === null || a === void 0 ? void 0 : a(f) : l === null || l === void 0 ? void 0 : l(f);
          case 21:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
}
function O(e) {
  return "preventDefault" in e && typeof e.preventDefault == "function";
}
function U(e) {
  e.preventDefault();
  var t = e.currentTarget;
  if (t.tagName != "FORM") throw new Error("submit was triggered for a non-form element");
  return new FormData(t);
}
function z(e) {
  var t = {
    address: I(e)
  };
  for (var _i2 = 0, _arr = ["name", "email", "phone"]; _i2 < _arr.length; _i2++) {
    var s = _arr[_i2];
    var r = e instanceof FormData ? e.get(s) : e[s];
    r && typeof r == "string" && (t[s] = r);
  }
  return t;
}
function I(e) {
  var t = {};
  for (var _i3 = 0, _arr2 = [["address_line1", "line1"], ["address_line2", "line2"], ["address_city", "city"], ["address_country", "country"], ["address_state", "state"], ["address_postal_code", "postal_code"]]; _i3 < _arr2.length; _i3++) {
    var _arr2$_i = _slicedToArray(_arr2[_i3], 2),
      s = _arr2$_i[0],
      r = _arr2$_i[1];
    var i = e instanceof FormData ? e.get(s) : e[s];
    i && typeof i == "string" && (t[r] = i);
  }
  return t;
}
function W(e) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _d = d(null),
    _d2 = _slicedToArray(_d, 2),
    s = _d2[0],
    r = _d2[1],
    _d3 = d(null),
    _d4 = _slicedToArray(_d3, 2),
    i = _d4[0],
    a = _d4[1],
    _d5 = d(!1),
    _d6 = _slicedToArray(_d5, 2),
    l = _d6[0],
    n = _d6[1],
    _d7 = d(!1),
    _d8 = _slicedToArray(_d7, 2),
    o = _d8[0],
    m = _d8[1];
  if (!e) throw new Error('You must provide a form key or hashid (e.g. useForm("myForm") or useForm("123xyz")');
  var S = x(e, {
    client: t.client,
    extraData: t.data,
    onError: function onError(p) {
      r(p), n(!1), m(!1);
    },
    onSuccess: function onSuccess(p) {
      r(null), a(p), n(!1), m(!0);
    },
    origin: t.endpoint
  });
  return [{
    errors: s,
    result: i,
    submitting: l,
    succeeded: o
  }, /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(u) {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            n(!0);
            _context2.next = 3;
            return S(u);
          case 3:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }(), function () {
    r(null), a(null), n(!1), m(!1);
  }];
}
export { me as CardElement, _ as FormspreeProvider, T as ValidationError, W as useForm, F as useFormspree, x as useSubmit };